import React from 'react';
import PropTypes from 'prop-types';

import formStyles from '../styles/styles.module.scss';
import baseStyles from '../../../styles/baseStyles.module.scss';
import styles from './styles/styles.module.scss';
// Todo: Refactor this to build footer independently, based on prop
const Wrapper = ({ text, foot, children, showStepText, extraContainerClass }) => {
  return (
    <div>
      <div className={`${baseStyles.container} ${formStyles.container} ${styles.wrapper} ${extraContainerClass}`}>
        <div className={formStyles.head}>
          <div className={formStyles.subHead}>{text.headText}</div>
          <div className={formStyles.step}>{showStepText ? text.stepText : ''}</div>
        </div>
        {children}
        {foot && <div className={formStyles.foot}>{foot}</div>}
      </div>
    </div>
  );
};

Wrapper.propTypes = {
  text: PropTypes.shape({
    headText: PropTypes.string
  }),
  foot: PropTypes.element,
  showStepText: PropTypes.bool,
  extraContainerClass: PropTypes.string
};

Wrapper.defaultProps = {
  text: {
    headText: 'Header'
  },
  foot: <div />,
  showStepText: false,
  extraContainerClass: ''
};

export default Wrapper;
